import classNames from 'classnames'

import {
  DATE_SHORT_FORMAT,
  DATE_WEEKDAY_NAME_FORMAT,
} from '../../../../../constants/date'
import { useDateLocale } from '../../../../../hooks'
import Text from '../../../../Text'
import { formatCalendarGridDay } from '../../../CalendarGrid.utils'

import * as styles from './CalendarGridAgendaDayTitle.module.css'

function CalendarGridAgendaDayTitle({ day, isToday }) {
  const locale = useDateLocale()

  const labelClassName = classNames({ [styles.today]: isToday })

  return (
    <div className={styles.CalendarGridAgendaDayTitle}>
      <Text className={labelClassName}>
        {formatCalendarGridDay({
          dateFormat: DATE_WEEKDAY_NAME_FORMAT,
          day: day.date,
          locale,
        })}
      </Text>
      <Text className={labelClassName}>
        {formatCalendarGridDay({
          dateFormat: DATE_SHORT_FORMAT,
          day: day.date,
        })}
      </Text>
    </div>
  )
}

export default CalendarGridAgendaDayTitle
